import React, {Component} from 'react';

import qr from '../assets/gh_16aae4351783_258.jpg';

export default class Bottom extends Component{
    render(){
        return (
            <div className="bottom">
                    <div className="body">
                        <div>
                            <h4>关于搜图鸭</h4>
                            <div>搜图鸭是一款可以在线下载图片和视频的产品，</div>
                            <div>您只需要输入链接既可以快速解析并下载.</div>
                        </div>
                        <div>
                            <h4>PC端使用</h4>
                            <div>PC端您可以访问我们的<a href="/">PC网址</a></div>
                        </div>
                        <div style={{
                            display : "flex"
                        }}>
                            <div>
                                <h4>移动端使用</h4>
                                <div>微信扫一扫右侧二维码</div>
                                <div>使用小程序下载更方便</div>
                            </div>
                            <div>
                                <img src={qr} style={{
                                    width : '80px',
                                    marginLeft : "10px"
                                }} alt=""/>
                            </div>
                        </div>
                        <div>
                            <h4>联系我们</h4>
                            <div>添加微信：successToast</div>
                        </div>
                    </div>
            </div>
        )
    }
}